document.addEventListener("DOMContentLoaded", function() {
  
  const mobileMenu = document.querySelector('.mer-navigation__mobile-nav-wrapper')
  const burger = document.querySelector('.mer-navigation__burger');

  burger.addEventListener('click', (event) => {
    console.log(event.target);
    if (burger.classList.contains('active')) {
      burger.classList.remove('active');
      mobileMenu.classList.add('hidden')
    } else {
      mobileMenu.classList.remove('hidden')
      burger.classList.add('active');
    }
  })
});
